import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { authApi } from '@/utilities/axios';
import EventBus from '../../../../../utilities/event-bus';
import { useAuthStore } from '@/modules/auth/store';
import { showToast } from '@/utilities/toast-handler';
const LEARNING_OUTCOME_URL = process.env.VUE_APP_API_VERSION + '/learning-outcome';
export const useLearningOutcomeStore = defineStore('learningOutcome', () => {
    const authStore = useAuthStore();

    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });
    const LOKeyIndex = ref(0);
    //state
    const learningOutcome = ref({
        appliance_id: null,
        company_id: null,
        learning: null,
        complete: null,
    });

    const learningOutcomes = ref([]);

    //actions
    const createLearningOutcomes = async (learningOutcomeData, debriefId) => {
        try {
            const bodyParams = { ...learningOutcomeData, company_id: company_id.value, debrief_id: debriefId };
            const response = await authApi.post(LEARNING_OUTCOME_URL, bodyParams);
            if (response.statusCode === 201) {
                learningOutcomes.value?.push(response.data);
                showToast(response.toast, 'Learning Outcome created successfully');
                return true;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to create learning outcomes');
        }
    };

    const updateLearningOutcome = async (learningOutcomeData) => {
        try {
            EventBus.emit('show-operation-loader');
            const response = await authApi.patch(`${LEARNING_OUTCOME_URL}/${learningOutcomeData.learning_id}`, learningOutcomeData);
            if (response.statusCode === 200) {
                showToast(response.toast, 'Learning Outcome updated successfully');
                return true;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to update Learning Outcome');
        } finally {
            EventBus.emit('hide-operation-loader');
        }
    };

    const deleteLearningOutcome = async (learningOutcomeId) => {
        try {
            EventBus.emit('show-operation-loader');
            const response = await authApi.delete(`${LEARNING_OUTCOME_URL}/${learningOutcomeId}`, {
                params: {
                    companyId: company_id.value,
                },
            });
            if (response.statusCode === 200) {
                showToast({ severity: 'info', summary: 'Unlinked' }, 'Learning Outcome' + learningOutcomeId + ' removed from debrief successfully');
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to delete LearningOutcome');
        } finally {
            EventBus.emit('hide-operation-loader');
        }
    };

    const sendToRolNolJol = async (outcomeLearningData) => {
        try {
            const bodyparams = { send_option: outcomeLearningData.sendOption };
            const response = await authApi.post(`${LEARNING_OUTCOME_URL}/${outcomeLearningData.learningId}/${outcomeLearningData.operationType}?company_id=${company_id.value}`, bodyparams);
            if (response.statusCode === 200) {
                showToast(response.toast, 'Status update');
                return true;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to update status for ' + outcomeLearningData.operationType);
        }
    };

    //helper
    const addLearningOutcomeTab = () => {
        learningOutcomes.value.push({
            key: LOKeyIndex.value,
            debrief_id: null,
            theme_id: null,
            company_id: null,
            source_id: null,
            details: null,
            complete: 0,
            outcome_type: null,
            attachments: [],
        });
        LOKeyIndex.value++;
    };

    const loadEditLearningOutcomes = (learningOutcomesData) => {
        for (let i = 0; i < learningOutcomesData.length; i++) {
            learningOutcomes.value.push({
                learning_id: learningOutcomesData[i]?.id,
                debrief_id: learningOutcomesData[i]?.debrief_id,
                theme_id: learningOutcomesData[i]?.theme_id,
                company_id: learningOutcomesData[i]?.company_id,
                source_id: learningOutcomesData[i]?.source_id,
                details: learningOutcomesData[i]?.details,
                complete: learningOutcomesData[i]?.complete,
                outcome_type: Number(learningOutcomesData[i].outcome_type),
                attachments: learningOutcomesData[i]?.attachments?.map((attachment) => {
                    return {
                        id: attachment.pivot?.attachment_id,
                        caption: attachment.caption,
                        description: attachment.description,
                        original_name: attachment.original_name,
                        extension: attachment.extension,
                    };
                }),
                source: learningOutcomesData[i]?.source,
                theme: learningOutcomesData[i]?.theme,
                send_to_regional_operational_learning: Number(learningOutcomesData[i]?.send_to_rol_outcome),
                send_to_national_operational_learning: Number(learningOutcomesData[i]?.send_to_nol_outcome),
                send_to_joint_operational_learning: Number(learningOutcomesData[i]?.send_to_jol_outcome),
                task: learningOutcomesData[i]?.task,
            });
        }
    };

    const initLearningOutcomes = () => {
        learningOutcomes.value = [];
    };

    return {
        //state
        learningOutcome,
        learningOutcomes,

        //actions
        createLearningOutcomes,
        updateLearningOutcome,
        deleteLearningOutcome,
        sendToRolNolJol,

        //helpers
        addLearningOutcomeTab,
        loadEditLearningOutcomes,
        initLearningOutcomes,
    };
});
